module.exports = __webpack_public_path__ + "img/card-blog3.47bb87fb.jpg";